import { useEffect } from 'react';
import { useMutation } from 'react-query';

import { axios } from '@/library/axios';
import type { BaseResponse } from '@/types';
import { displayError } from '@/utils/functions/displayError';

import type { LoanEligibility, TopupEligibilityReq } from './types';

const checkTopupEligibility = async (payload: TopupEligibilityReq) => {
  const res = await axios<
    TopupEligibilityReq,
    BaseResponse<LoanEligibility>,
    TopupEligibilityReq
  >({
    url: '/glfh/top-up/assertion-of-eligibility',
    method: 'post',
    data: {
      ...payload,
    },
  });

  return res?.data?.data;
};

export const useTopupEligibility = () => {
  const { mutateAsync, data, isLoading, error } = useMutation(
    checkTopupEligibility
  );

  useEffect(() => {
    displayError(error);
  }, [error]);

  return { checkTopupEligibility: mutateAsync, data, isLoading };
};
